import React, { useMemo, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useReactToPrint } from "react-to-print";
import bill from 'assets/images/1bill.jpg';
import alfalah from 'assets/images/alfa.png';
import nbp from 'assets/images/nbp.jpg';
import hbl from 'assets/images/hbl-c.png';
import ubllogo from 'assets/images/ubl_new.png';
import bzuLogo from 'assets/images/BZU-logo.png';
import QRCode from "react-qr-code";
import { buildBzuVoucherQrStringFromVoucher } from "utils/buildBzuVoucherQrString";

// Sample student data - you'll replace this with API data later
const studentData = {
  voucherNo: "6240012048",
  billInvNo: "10011451506240012048",
  studentName: "Muhammad Huzaifa",
  fatherName: "Muhammad Ikram",
  studentCNIC: "36302-5592926-7",
  rollNo: "BSCSM-24-2331",
  semesterNo: "2",
  session: "2024",
  department: "Department of Computer Science",
  program: "BS(CS)",
  shift: "Morning - Fall Semester",
  admissionType: "Open Merit",
  issueDate: "17-Mar-2025",
  validUpto: "31-Mar-2025",
  fees: "PKR 36,250/-",
  feesInWords: "Thirty-six Thousand Two Hundred Fifty"
};

// Compact VoucherSection component for landscape printing
const VoucherSection = ({ title, images, admissionVoucher, qrValue }) => {
  return (
    <Box sx={{ 
      border: "1px solid #000", 
      p: 0.25, 
      height: "100%", 
      fontSize: "10px" // Reduced font size for landscape mode
    }}>
      <Grid container>
        {/* Header Row */}
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={3} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }} style={{ textAlign: "center", alignItems: "center" }}>
              <Typography variant="body2" fontSize="12px" fontWeight="bold">{title}</Typography>
            </Grid>
            <Grid item xs={9} sx={{ borderBottom: "1px solid #000", p: 0.25 }} style={{ textAlign: "center", alignItems: "center" }}>
              <Typography variant="body2" fontSize="12px">Voucher no: <strong>{admissionVoucher.challan_no}</strong></Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Bill Row */}
        <Grid item xs={12}>
          <Grid container sx={{ borderBottom: "1px solid #000" }}>
            <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box component="img" src={images.bill} alt="1BILL" sx={{ height: 35, maxWidth: "100%" }} />
            </Grid>
            <Grid item xs={9} sx={{ p: 0.25 }}>
              <Typography variant="body2" fontSize="10px" fontWeight="bold" style={{ textAlign: "center", alignItems: "center" }}>All Mobiles Banking Channels</Typography>
              <Typography variant="body2" fontSize="10px" style={{ textAlign: "center", alignItems: "center" }}>1 Bill Inv. ID/Consumer No.</Typography>
              <Typography variant="body2" fontSize="10px" fontWeight="bold" style={{ textAlign: "center", alignItems: "center" }}>1016205150{admissionVoucher.challan_no}</Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* UBL Row */}
        
        <Grid item xs={12}>
          <Grid container sx={{ borderBottom: "1px solid #000" }}>
            <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box component="img" src={images.ubl} alt="UBL" sx={{ height: 30, maxWidth: "90%" }} />
            </Grid>
            <Grid item xs={9} sx={{ p: 0.25 }}>
              <Typography variant="body2" fontSize="10px" fontWeight="bold" style={{ textAlign: "center", alignItems: "center" }}>BZU Morning Students Fee</Typography>
              <Typography variant="body2" fontSize="10px" style={{ textAlign: "center", alignItems: "center" }}>BZUMSFCC</Typography>
            </Grid>
          </Grid>
        </Grid>
    
        {/* Bank Alfalah Row */}
        <Grid item xs={12}>
          <Grid container sx={{ borderBottom: "1px solid #000" }}>
            <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box component="img" src={images.alfalah} alt="Bank Alfalah" sx={{ height: 40, maxWidth: "100%" }} />
            </Grid>
            <Grid item xs={9} sx={{ p: 0.25 }}>
              <Typography variant="body2" fontSize="10px" style={{ textAlign: "center", alignItems: "center" }}>To be posted in <strong>Alfalah Transact</strong> via <strong>Fee <br/>Collection tab</strong> (API)</Typography>
              <Typography variant="body2" fontSize="10px" fontWeight="bold" style={{ textAlign: "center", alignItems: "center" }}>BAHAUDDIN ZAKARIYA UNIVERSITY MULTAN</Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* NBP Row */}
        <Grid item xs={12}>
          <Grid container sx={{ borderBottom: "1px solid #000" }}>
            <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box component="img" src={images.nbp} alt="NBP" sx={{ height: 20, maxWidth: "100%" }} />
            </Grid>
            <Grid item xs={9} sx={{ p: 0.25 }} style={{ textAlign: "center", alignItems: "center" }}>
              <Typography variant="body2" fontSize="10px" fontWeight="bold">Collection Via NBP CMS</Typography>
              <Typography variant="body2" fontSize="10px">(Inst.Cir#:197/2024)</Typography>
              <Typography variant="body2" fontSize="10px" fontWeight="bold">BZU Morning Fee - API</Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* HBL CONNECT Row */}
        <Grid item xs={12}>
          <Grid container sx={{ borderBottom: "1px solid #000" }}>
            <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box component="img" src={images.hbl} alt="HBL" sx={{ height: 30, maxWidth: "100%" }} />
            </Grid>
            <Grid item xs={9} sx={{ p: 0.25 }} style={{ textAlign: "center", alignItems: "center" }}>
              <Typography variant="body2" fontSize="10px" fontWeight="bold">Pay digitally through</Typography>
              <Typography variant="body2" fontSize="10px" fontWeight="bold">HBL / Konnect App or Konnect Agent</Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* University Logo Row */}
        <Grid item xs={12}>
          <Grid container sx={{ borderBottom: "1px solid #000" }}>
            <Grid item xs={3} sx={{ borderRight: "1px solid #000", p: 0.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box component="img" src={images.bzuLogo} alt="BZU Logo" sx={{ height: 60, maxWidth: "100%" }} />
            </Grid>
            <Grid item xs={9} sx={{ p: 0.25 }} style={{ textAlign: "center", alignItems: "center" }}>
              <Typography variant="body2" fontSize="13px" fontWeight="bold">Bahauddin Zakariya <br/>University, Multan</Typography>
              <Typography variant="body2" fontSize="13px" fontWeight="bold">(PAKISTAN)</Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Department Row */}
        <Grid item xs={12} sx={{ bgcolor: "#000", color: "#fff", p: 0.25, textAlign: "center" }}>
          <Typography variant="body2" fontSize="10px" fontWeight="bold">{admissionVoucher.label || "Admission Processing Fee"}</Typography>
        </Grid>


        {/* Student Details Table */}
        <Grid item xs={12}>
          <Box sx={{ width: "100%" }} style={{ textAlign: "center" }}>
            {/* Issue Date Row */}
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">Issue Date</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">{new Date(admissionVoucher.print_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}
                </Typography>
              </Grid>
            </Grid>

            {/* Student Name Row */}
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">Name</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">{admissionVoucher.name}</Typography>
              </Grid>
            </Grid>

            {/* Father Name Row */}
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">Father Name</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">{admissionVoucher.father_name}</Typography>
              </Grid>
            </Grid>

            {/* Student CNIC Row */}
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">CNIC</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">{admissionVoucher.cnic}</Typography>
              </Grid>
            </Grid>

            {/* Roll No Row */}
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">Form No.</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">{admissionVoucher.form_no}</Typography>
              </Grid>
            </Grid>


            {/* Session Row */}
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">Session</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">{admissionVoucher.session}</Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">Processing Fee</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">PKR {admissionVoucher.processing_fee}/-</Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">Test Fee</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">PKR {admissionVoucher.test_fee}/-</Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">Paid Amount</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px">PKR {admissionVoucher.paid_amount}/-</Typography>
              </Grid>
            </Grid>
            {/* Fees Payable Row */}
            <Grid container>
              <Grid item xs={4} sx={{ borderRight: "1px solid #000", borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px" fontWeight="bold">Fees Payable</Typography>
              </Grid>
              <Grid item xs={8} sx={{ borderBottom: "1px solid #000", p: 0.25 }}>
                <Typography variant="body2" fontSize="10px" fontWeight="bold">PKR {admissionVoucher.amount}/-</Typography>
              </Grid>
            </Grid>

            {/* Fees In Words Row */}
            <Grid container>
              <Grid item xs={12} sx={{ borderBottom: "1px solid #000", p: 0.25, textAlign: "center" }}>
                <Typography variant="body2" fontSize="10px" fontWeight="bold"><i>{admissionVoucher.amount_in_words}</i></Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* QR Code Row */}
        <Grid item xs={12} sx={{ textAlign: "center", p: 0.5, borderBottom: "1px solid #000" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 108,
              bgcolor: "#fff",
              "@media print": {
                minHeight: 120,
                "& .voucher-qr-svg": {
                  width: "110px !important",
                  height: "110px !important",
                },
              },
            }}
          >
            {qrValue ? (
              <>
                <QRCode
                  value={qrValue}
                  size={100}
                  level="L"
                  bgColor="#FFFFFF"
                  fgColor="#000000"
                  className="voucher-qr-svg"
                  style={{ height: 100, width: 100, display: "block" }}
                />
                <Typography
                  variant="body2"
                  sx={{ fontSize: "8px", mt: 0.25, lineHeight: 1.2 }}
                >
                  Scan to Pay
                </Typography>
              </>
            ) : null}
          </Box>
        </Grid>

        {/* Valid Date Row */}
        <Grid item xs={12} sx={{ p: 0.25, borderBottom: "1px solid #000", textAlign: "center" }}>
          <Typography variant="body2" fontSize="10px">This Challan is Valid up to<strong> {new Date(admissionVoucher.due_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric',timeZone: 'Asia/Karachi' })}</strong></Typography>
        </Grid>

        {/* Signature Row */}
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={6} sx={{ borderRight: "1px solid #000", p: 0.25, textAlign: "center" }}>
              <Typography variant="body2" fontSize="10px">Sign Officer</Typography>
            </Grid>
            <Grid item xs={6} sx={{ p: 0.25, textAlign: "center" }}>
              <Typography variant="body2" fontSize="10px">Sign Cashier</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

// Main VoucherDialog component
const VoucherDialog = ({ voucherModal, handleCloseVoucherModal, admissionVoucher }) => {
  const componentRef = useRef();

  const qrValue = useMemo(() => {
    if (!admissionVoucher?.challan_no) return "";
    try {
      return buildBzuVoucherQrStringFromVoucher(admissionVoucher);
    } catch (error) {
      console.error("Failed to build voucher QR string:", error);
      return "";
    }
  }, [admissionVoucher]);
  
  // Import all the required images
  const images = {
    bill: bill,
    alfalah: alfalah,
    nbp: nbp,
    ubl: ubllogo,
    hbl: hbl,
    bzuLogo: bzuLogo,
  };
  
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Dialog
      open={voucherModal}
      onClose={handleCloseVoucherModal}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: "100%", 
          width: "100%"
        }
      }}
    >
      <DialogContent>
        <Box ref={componentRef} sx={{ p: 0.5 }}>
          <Grid container spacing={0.5}>
            {/* Voucher copies - 4 sections in a row */}
            <Grid item sm={3}>
              <VoucherSection title="Department" images={images} admissionVoucher={admissionVoucher} qrValue={qrValue} />
            </Grid>
            <Grid item sm={3}>
              <VoucherSection title="Student" images={images} admissionVoucher={admissionVoucher} qrValue={qrValue} />
            </Grid>
            <Grid item sm={3}>
              <VoucherSection title="BZU,Multan" images={images} admissionVoucher={admissionVoucher} qrValue={qrValue} />
            </Grid>
            <Grid item sm={3}>
              <VoucherSection title="Bank" images={images} admissionVoucher={admissionVoucher} qrValue={qrValue} />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseVoucherModal} color="primary">
          Close
        </Button>
        <Button onClick={handlePrint} color="primary" variant="contained" style={{ color: "white" }}>
          Print Voucher
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VoucherDialog;